export default __webpack_public_path__ + "static/media/vehicle.69960d7b6d03552bb740af1afbba7047.svg";